import { render, staticRenderFns } from "./axis-style.md?vue&type=template&id=00e3f383&"
import script from "./axis-style.md?vue&type=script&lang=js&"
export * from "./axis-style.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00e3f383')) {
      api.createRecord('00e3f383', component.options)
    } else {
      api.reload('00e3f383', component.options)
    }
    module.hot.accept("./axis-style.md?vue&type=template&id=00e3f383&", function () {
      api.rerender('00e3f383', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/plugin/axis/axis-style.md"
export default component.exports